export default __webpack_public_path__ + "742ab4631357390e7669d60e5bfef602.jpg";